import { Injectable, signal } from '@angular/core';

export interface Alert {
  message: string;
  type: 'success' | 'info' | 'error';
  duration?: number;
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  alert = signal<Alert | null>(null);
  alertVisible = signal<boolean>(false);

  private defaultDuration = 3000; // 3 seconds

  private alertTimeout: any;

  showAlert(
    message: string,
    type: 'success' | 'info' | 'error',
    duration?: number
  ): void {
    const alert: Alert = {
      message,
      type,
      duration: duration || this.defaultDuration,
    };
    this.alert.set(alert);
    this.alertVisible.set(true);

    // Clear any existing timeout before setting a new one
    if (this.alertTimeout) {
      clearTimeout(this.alertTimeout);
    }

    // Clear the alert after the specified duration
    this.alertTimeout = setTimeout(() => {
      this.setAlertInvisible();
    }, alert.duration);
  }

  showSuccessAlert(message: string, duration?: number): void {
    this.showAlert(message, 'success', duration);
  }

  showInfoAlert(message: string, duration?: number): void {
    this.showAlert(message, 'info', duration);
  }

  showErrorAlert(message: string, duration: number = 10000): void {
    this.showAlert(message, 'error', duration);
  }

  hideAlert(): void {
    if (this.alertTimeout) {
      clearTimeout(this.alertTimeout);
    }
    if (this.alert()) {
      this.setAlertInvisible();
    }
  }

  setAlertInvisible(): void {
    this.alertVisible.set(false);

    setTimeout(() => {
      this.alert.set(null);
    }, 500);
  }
}
